import { Clickable, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors } = theme;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const Label = styled(P)`
  margin-bottom: 0;
`;

export const StyledButton = styled(Clickable)<{ disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')} !important;
  display: flex;
  margin: 0 1rem;

  &:focus {
    border-radius: 3rem;
  }
`;

export const StyledP = styled(P)`
  color: ${colors.grey50};
`;

export const StyledSpan = styled.span`
  font-size: 1.25rem;
  text-align: center;
  width: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
